import React from 'react';

export default function ShippingPolicy() {
  return (
    <div className="min-h-screen bg-background py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-serif text-4xl font-semibold text-stone-900 mb-2">Shipping Policy</h1>
        <p className="text-muted-foreground mb-8 text-sm italic">Effective Date: 01-Mar-2026</p>
        
        <div className="prose prose-stone max-w-none space-y-8">
          <p className="text-stone-700 leading-relaxed">
            Thank you for shopping with SriSuktam Organics. We are committed to delivering your rice, pulses, cold-pressed oils, and other products safely and on time.
          </p>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">1. Order Processing Time</h2>
            <ul className="list-disc pl-5 text-stone-600 space-y-2">
              <li>Orders are processed within 1–2 business days after payment confirmation.</li>
              <li>Orders placed on Sundays or public holidays will be processed on the next working day.</li>
              <li>You will receive an order confirmation and tracking details via email, SMS, or WhatsApp once shipped.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">2. Delivery Timeline</h2>
            <div className="bg-muted p-6 rounded-2xl border border-stone-200">
              <p className="text-stone-800 font-medium mb-2">Estimated delivery time:</p>
              <ul className="list-disc pl-5 text-stone-600 space-y-1">
                <li>Metro Cities: 2–4 business days</li>
                <li>Other Locations: 3–7 business days</li>
                <li>Remote Areas: 5–9 business days</li>
              </ul>
              <p className="text-stone-500 text-xs mt-4 italic">Delivery times may vary due to logistics conditions, weather, or unforeseen delays.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">3. Shipping Charges</h2>
            <ul className="list-disc pl-5 text-stone-600 space-y-1">
              <li>Shipping charges (if applicable) will be calculated at checkout.</li>
              <li>We may offer free shipping on orders above a certain value (as displayed on the website).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">4. Delivery Partners</h2>
            <p className="text-stone-600">
              We work with reliable courier and logistics partners to ensure safe delivery. Once the order is handed over to the courier, tracking responsibility shifts to the delivery partner.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">5. Order Tracking</h2>
            <p className="text-stone-600 mb-2">After dispatch, you will receive:</p>
            <ul className="list-disc pl-5 text-stone-600 space-y-1">
              <li>Tracking number</li>
              <li>Courier partner details</li>
              <li>Estimated delivery date</li>
            </ul>
            <p className="text-stone-600 mt-2">You can track your order using the link provided in your confirmation email or SMS.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">6. Delivery Issues</h2>
            <p className="text-stone-600 mb-2">If you experience any of the following:</p>
            <ul className="list-disc pl-5 text-stone-600 space-y-1">
              <li>Package damaged during transit</li>
              <li>Missing items</li>
              <li>Wrong product delivered</li>
              <li className="italic text-stone-500 text-sm italic">All images on the website is for the illustration purpose only not the exact product image</li>
            </ul>
            <p className="text-stone-800 font-medium mt-4">Please contact us within 48 hours of delivery with clear photos for resolution.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">7. Address Accuracy</h2>
            <p className="text-stone-600">
              Customers are responsible for providing accurate shipping details. We are not responsible for delays or non-delivery due to incorrect address information.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">8. Failed Delivery Attempts</h2>
            <p className="text-stone-600 mb-2">If delivery fails due to:</p>
            <ul className="list-disc pl-5 text-stone-600 space-y-1">
              <li>Customer unavailable</li>
              <li>Incorrect address</li>
              <li>Refusal to accept delivery</li>
            </ul>
            <p className="text-stone-600 mt-2">Additional shipping charges may apply for re-dispatch.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">9. International Shipping</h2>
            <p className="text-stone-600">
              Currently, we do not ship internationally. If international shipping is available, customs duties and import taxes are the responsibility of the customer.
            </p>
          </section>

          <section className="bg-secondary/5 p-6 rounded-2xl border border-secondary/10">
            <h2 className="text-xl font-semibold text-stone-900 mb-2">10. Contact Us</h2>
            <p className="text-stone-700">For shipping-related queries:</p>
            <div className="mt-4">
              <p className="font-semibold text-secondary">SriSuktam Organics</p>
              <p className="text-stone-600">Email: <a href="mailto:srisuktamorganics@gmail.com" className="hover:underline">srisuktamorganics@gmail.com</a></p>
              <p className="text-stone-600 text-sm italic mt-2">Working Hours: Monday – Saturday, 9:30 AM – 6:30 PM</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
